import { useParams } from 'react-router';
import ShippingListHead from '../components/ShippingListHead';
import ShippingListTable from '../components/table/ShippingListTable';
import { useEffect, useState } from 'react';
import buskwarehousedetail from '../services/buskwarehousedetail';
import { stateKorea } from '../../utils/Languages';

const ShippingList = () => {
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(false);
  // shipping list
  const [deliveriesCount, setDeliveriesCount] = useState(0);
  const [deliveriesRowData, setDeliveriesRowData] = useState();
  const [selectedDeliveries, setSelectedDeliveries] = useState<React.Key[]>([]);
  const [pageDelivery, setPageDelivery] = useState(1);
  const handleChangePageDelivery = (page: number) => {
    setPageDelivery(page);
  };

  const getDeliveries = async (id: string, page: number) => {
    setLoading(true);
    const data = await buskwarehousedetail.getDeliveries(id, page);
    const rowDataModified = data.data?.map((r: any) => {
      return {
        ...r,
        key: r.id,
        // no: index + (page - 1) * 10 + 1,
        no: r.id,
        state: stateKorea(r.state)
      };
    });
    setDeliveriesRowData(rowDataModified);
    setDeliveriesCount(data.count);
    setLoading(false);
  };

  useEffect(() => {
    getDeliveries(id, pageDelivery);
  }, [id, pageDelivery]);

  return (
    <>
      <ShippingListHead
        totalDeliveries={deliveriesCount}
        selectedDeliveries={selectedDeliveries}
      />
      <ShippingListTable
        loading={loading}
        totalDeliveries={deliveriesCount}
        deliveriesRowData={deliveriesRowData}
        selectedDeliveries={selectedDeliveries}
        setSelectedDeliveries={setSelectedDeliveries}
        page={pageDelivery}
        handleChangePage={handleChangePageDelivery}
      />
    </>
  );
};

export default ShippingList;
